/*******************************************************************************
 * @ngdoc object
 * @name  csm.payments.data.type:WebPaymentInfo
 * @description
 * Information passed to service prior to checkout. Includes shopping cart info
 * and billing information, if required. This object is passed to a service that
 * calls the payment processor to generate a charge.
 *******************************************************************************/
export function webPaymentConfig(TypeFactoryProvider) {
  TypeFactoryProvider.addType({
    name: 'PaymentsData.WebPaymentInfo',
    $type: 'csm.payments.data.WebPaymentInfo, PaymentsCS',
    prototype: {
      cartInfo: [], // Shopping cart contents (CartInfo) for each processor.
      billingInfo: null, // Billing name and address from entry dialogs (BillingInfo).
      returnURL: null, // URL to load when user submits payment.
      cancelURL: null, // URL to load when user cancels payment.
      configData: null // Processor specific configuration info. Handled by processor API.
    },
    constructor: function (PaymentsData) {
      return function (info) {
        this.defaultConstructor(info);
        this.cartInfo = info.cartInfo.map((ci) =>
          PaymentsData.CartInfo.newInstance(ci)
        );
        this.billingInfo = this.billingInfo
          ? PaymentsData.BillingInfo.newInstance(this.billingInfo)
          : null;
      };
    }
  });

  TypeFactoryProvider.addType({
    name: 'PaymentsData.BillingInfo',
    $type: 'csm.payments.data.BillingInfo, PaymentsCS',
    prototype: {
      cardToken: null, // Card token generated by payment processor.
      firstName: null, // Cardholder first name.
      lastName: null, // Cardholder last name.
      address: null, // Street address.
      city: null, // City name.
      state: null, // State acronym.
      zipCode: null // Zip code in zip or zip+4.
    }
  });

  TypeFactoryProvider.addType({
    name: 'PaymentsData.CartInfo',
    $type: 'csm.payments.data.CartInfo, PaymentsCS',
    defaults: {
      totalPrice: 0, // Pre-tax total.
      totalTax: 0, // Total tax.
      total: 0, // Cart total.
      items: [] // Item list (CartItem).
    },
    constructor: function (PaymentsData) {
      return function (info) {
        this.defaultConstructor(info);
        this.items = this.items.map(function (item) {
          return PaymentsData.CartItem.newInstance(item);
        });
      };
    }
  });

  TypeFactoryProvider.addType({
    name: 'PaymentsData.CartItem',
    $type: 'csm.payments.data.CartItem, PaymentsCS',
    prototype: {
      name: null, // Item name.
      qty: 0, // Item quantity.
      price: 0, // Item price.
      tax: 0 // Item tax amount.
    }
  });
};

webPaymentConfig.$inject = ['TypeFactoryProvider'];
